import styled from 'styled-components'

export const Wrapper = styled.div`
  margin: 10px 0;
`

export const Input = styled.input`
  vertical-align: sub;
  margin: 0;
  width: 1em;
  height: 1em;
`

export const Label = styled.label`
  display: block;
  cursor: pointer;
`

export const Span = styled.span`
  font-weight: 400;
  margin-left: .5em;
`